import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GamesGroup } from './models/games-group.model';

export interface GamesGroupState extends EntityState<GamesGroup> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'games-group', idKey: 'GroupId' })
export class GamesGroupStore extends EntityStore<GamesGroupState> {
  constructor() {
    super();
  }
}
